var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 840,
    viewBox: "0 0 1440 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_228707)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 840,
    fill: "#131316"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_504_228707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.749 565.756C417.82 447.101 445.14 282.035 563.77 197.071L624.128 153.841C742.758 68.8771 907.775 96.1887 992.704 214.843L1035.22 274.245C1120.15 392.9 1092.83 557.966 974.202 642.93L913.843 686.159C795.214 771.124 630.196 743.812 545.267 625.157L502.749 565.756Z",
    fill: "url(#paint0_radial_504_228707)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_504_228707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.128 411.665C610.989 501.258 503.091 538.75 413.509 495.589C323.927 452.428 285.972 344.662 329.111 255.07C372.25 165.478 480.148 127.985 569.73 171.146C659.312 214.308 697.268 322.073 654.128 411.665Z",
    fill: "url(#paint1_radial_504_228707)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_504_228707",
    x: 318.39,
    y: -30.548,
    width: 901.193,
    height: 901.098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.4839,
    result: "effect1_foregroundBlur_504_228707"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_504_228707",
    x: -95.6652,
    y: -253.734,
    width: 1174.57,
    height: 1174.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 203.483,
    result: "effect1_foregroundBlur_504_228707"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_504_228707",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(670.987 374.234) rotate(46.7564) scale(398.533 399.356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52A5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52A5E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_504_228707",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(561.729 370.94) rotate(-64.8881) scale(783.886 785.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A855F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A855F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_228707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 840,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBack);
export default __webpack_public_path__ + "static/media/loginBack.11b3ea0c0a68df9c17f60145484915be.svg";
export { ForwardRef as ReactComponent };